module.exports = __webpack_public_path__ + "img/thumbnail_ThomsonsGazelle_f_normal.4c2e60a1.png";